<div class="scrollable-container">
  <eds-toggle-v2
    [toggleButtons]="toggleButtons"
    [isNoWrap]="true"
    (toggleActive)="onTabChange($event)"
    [stopEventTracking]="true"
  ></eds-toggle-v2>
</div>
